import { createStore, applyMiddleware, compose } from 'redux'
import combinedRecucer from '../reducers'
import logger from 'redux-logger'

// const store = createStore(
//     combinedRecucer,
//     compose(applyMiddleware(logger))
// )
const composition = document.title == 'dev' ? compose(applyMiddleware(logger)) : compose()
const store = createStore(combinedRecucer,composition)

export default store;